var $15e4ef8d9b490a13$exports = {};
$15e4ef8d9b490a13$exports = {
    "backButton": (args)=>`Retour vers ${args.prevMenuButton}`,
    "moreActions": `Autres actions`,
    "unavailable": `Indisponible, d\xe9velopper pour plus de d\xe9tails`
};


export {$15e4ef8d9b490a13$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
